import React from 'react';
import { render } from '@testing-library/react';
import { Sidebar } from './Sidebar';
import { BodyText } from '../BodyText';

describe('Sidebar', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Sidebar
				localStorageKey="sidebar-stories__sidebar"
				data-auto-sel="automation-selector"
			>
				<BodyText>Sidebar</BodyText>
			</Sidebar>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
